import React from 'react';
import UnderwritingSingleTenant from '../UnderwritingSingleTenant';
import UnderwritingMultiTenant from '../UnderwritingMultiTenant';
import UnderwritingMultiFamily from '../UnderwritingMultiFamily';
import {convertPhoneNumber} from "../../utils";
import request from "arcdynamic-request";
import {AGENTS} from '../../consts/tables';
import Alert from "../Alert";
import { GET_TEAMMEMBER_BY_ID } from '../Graphql/Queries/TeamMemberQuery';
import { GET_AGENTS_BY_ID } from '../Graphql/queries';
import { ApolloConsumer } from '@apollo/client';
import { GET_AGENT_BY_CONTACTID, GET_CONTACT_TEAM_BY_ARCIMEDES_ID, GET_CONTACT_TEAM_BY_ID } from '../Graphql/ContactsQueries/contactsQuery';
import { fetchData } from '../Service/graphQlService';

const cloneDeep = require('lodash.clonedeep');

export default class Financials extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            newData: props.data,
            agents: [],
            agentIsCurrentUser: false,
            error: null,
            success: null,
        };
        this.client = null;
        this.handleChange = this.handleChange.bind(this);
        this.close = this.close.bind(this);
        this.setDataFromChild = this.setDataFromChild.bind(this);
        document.body.overflow = 'hidden';
    }


    static equals(agents, agentIds) {
        return agents.length === agentIds.length && agents.map((value, index) => value.id === agentIds[index]);
    }

    async componentDidMount() {
        const agents = this.state.agents;
        const teamAgentsIds = [this.props.data.listing_agent_1, this.props.data.listing_agent_2, this.props.data.listing_agent_3]
            .filter(id => id !== null && id !== undefined);
        const agentId = this.props.data.listing_agent_4;
        if (!agents.length) {
            const agentsIds = agentId ? [agentId] : teamAgentsIds;
            // const tableName = agentId ? GET_AGENTS_BY_ID : GET_TEAMMEMBER_BY_ID;
            const tableName = agentId ? GET_AGENT_BY_CONTACTID : GET_CONTACT_TEAM_BY_ARCIMEDES_ID;
            let agentIsCurrentUser = false;
            if (agentsIds && agentsIds.length && !Financials.equals(agents, agentsIds)) {
                await Promise.all(agentsIds.map(async id => {
                    const agentData = await this.getAgent(id, tableName, agentId);
                    if (agentData) {
                        const agent = {
                            id: id,
                            name: `${agentData.first_name} ${agentData.last_name}`,
                            phone: convertPhoneNumber(agentData.phone),
                            email: agentData.email || '',
                        };
                        agents.push(agent);
                        // if (tableName === 'GET_TEAMMEMBER_BY_ID' && agent.email === this.props.email) {
                        if (tableName === 'GET_CONTACT_TEAM_BY_ID' && agent.email === this.props.email) {
                            agentIsCurrentUser = true;
                        }
                    }
                }));

                this.setState({agents, agentIsCurrentUser});
            }
        }
    }

    async getAgent(id, tableName, agentId) {
        return fetchData(tableName,{[`${agentId? 'contactid': 'arcimedes_row_id'}`]: Number(id)})
        .then(res=>{
            if((res && res.data && res.data.getContactByContactid && res.data.getContactByContactid.contact) || (res && res.data && res.data.getContactTeamByArcId && res.data.getContactTeamByArcId.contact)){
                return res.data.getContactByContactid &&  res.data.getContactByContactid.contact ? res.data.getContactByContactid.contact : res.data.getContactTeamByArcId.contact ;
            }
        })
       
    }

    handleChange(e) {
        this.setData(e.currentTarget.name, e.currentTarget.value);
    }

    setData(key, value) {
        const data = {...cloneDeep(this.state.data), [key]: value};
        this.setState({data});
    }

    close() {
        this.props.close(true);
    }

    setDataFromChild({error = false, newData, savedTenants, newTenants, success}) {
        if (error) {
            this.setState({error}, () => {
                setTimeout(() => {
                    this.setState({error: null});
                }, 3000)
            });
            return;
        }
        const state = {
            success,
        };
        if (newData)
            state.newData = newData;
        this.setState(state, () => {
            setTimeout(() => {
                this.setState({success: null});
            }, 3000)
        });
        this.props.parentSetData({newData, savedTenants, newTenants});
    }
    
    componentWillUnmount() {
        document.body.overflow = 'auto';
    }

    render() {
        const data = this.state.newData;
        const {agents, agentIsCurrentUser, error, success, } = this.state;
        const isAgent = this.props.isAgent;
        const isSuper = this.props.isSuper;
        const proposalData = this.props.propsalData;

        return ( <ApolloConsumer>
            {
                client => {
                    if (!this.client) {
                        this.client = client;
                    }
                    return (

            <div className='Financials' lang='en-US' id="visible-print">
                {/* Multi-Family is decided by category before type: an apartment property once
                    typed STNL must still open the Multi-Family underwriting. */}
                {data.category === 'apartments' ?
                    <UnderwritingMultiFamily proposalData={proposalData} data={data} parentSetData={this.setDataFromChild} isAgent={isAgent} isSuper={isSuper} agents={agents} agentIsCurrentUser={agentIsCurrentUser}/>
                    : ['STNL', 'Other'].includes(data.type) ?
                    <UnderwritingSingleTenant proposalData = {proposalData} loation={this.props.location} data={data} parentSetData={this.setDataFromChild} isAgent={isAgent} isSuper={isSuper} agents={agents} agentIsCurrentUser={agentIsCurrentUser}/>
                    :
                    <UnderwritingMultiTenant proposalData = {proposalData} data={data} allTenantsById={this.props.allTenantsById} parentSetData={this.setDataFromChild} isAgent={isAgent} isSuper={isSuper} agents={agents} agentIsCurrentUser={agentIsCurrentUser}/>
                }
                {success ? <Alert type='success'>{success}</Alert> : null}
                {error ? <Alert type='error'>{error}</Alert> : null}
                <div className="close-button" onClick={this.close}/>
                <img src={arc.path.media+'stnl-background.png'} style={{visibility: 'hidden', position: 'absolute', width: 0, height: 0}}/>
            </div>
             )
            }
            }
            </ApolloConsumer>
        );
    }
}